/*
 * @Description:
 * @Date: 2020-11-06 16:31:41
 */

import baseRowlink from '@C/Base/baseRowlink';
import createExtend from '@C/createExtend';
import activeUpload from '../../active-upload';
import activeUpdate from '../../active-update';
import activePersonList from '../../active-person-list/index';
import activeDetail from '../../active-detail';
import addUsers from '@/page/project-personnel-inside/list/child/add-users';
import { activity, taxPayment } from '@/api/ajax';
import { MessageBox } from 'element-ui';
import { checkV3NoSigned } from '../../../../../methods/check';
const personsAdd = async ({ h, vm, row }) => {
  await checkV3NoSigned();
  await taxPayment.person.checkExportPersonnel({
    projectId: vm.$route.query.id
  });
  let dialog = vm.$xrkDialog;
  dialog.call(vm, {
    showConfirm: false,
    showCancel: false,
    $slots: {
      default: h(addUsers, {
        props: {
          downloadUrl: activity.downloadPersonTemplate,
          importData: activity.uploadPersons,
          query: { serviceActivityId: row.serviceActivityId }
        }
      })
    }
  });
};
const upload = ({ vm, row }) => {
  const c = createExtend(activeUpload, {
    serviceActivityId: row.serviceActivityId
  });
  c['$on']('confirm', () => {
    vm.saveSuccess();
  });
};
const errTips = (vm, data) => {
  if (data.messageFail) {
    let tipsContext = '';
    //已授权拦截信息
    if (data.noAuth.length > 0 && data.authList.length > 0) {
      const authList = data.authList.map(item => {
        return `<div style="background: #faf9f6;padding: 10px;">${item}</div>`;
      });
      //未授权拦截信息
      const noAuth = data.noAuth.map(item => {
        return `<div style="background: #faf9f6;padding: 10px;">${item}</div>`;
      });
      const mainStyle = `
          <div style="text-align: left;max-height: 500px;overflow-y: auto;">
            <div>
              <div style="
                background-color: #b1d7ff;
                color: #2d87ff;
                padding: 4px;
                font-size: 16px;
                display:${authList.length ? 'block' : 'none'}
                ">
                已授权拦截信息
              </div>
              ${authList.join('')}
            </div>
            <div>
              <div style="
                background-color: #b1d7ff;
                color: #2d87ff;
                padding: 4px;
                font-size: 16px;
                display:${noAuth.length ? 'block' : 'none'}
                ">
                未授权拦截信息
              </div>
              ${noAuth.join('')}
            </div>
          </div>
          `;
      tipsContext = mainStyle;
    } else {
      const noAuth = data.noAuth.join(',');
      tipsContext = noAuth;
    }
    MessageBox.confirm(tipsContext, '授权提示', {
      dangerouslyUseHTMLString: true,
      confirmButtonText: '查看明细',
      cancelButtonText: '已知晓',
      center: true
    }).then(async () => {
      vm.$router.push({
        path: '/projectPersonnelManage/list',
        query: {
          tableType: 'projectSettlementTask'
        }
      });
    });
    throw 'error';
  }
};
const submit = async ({ vm, row: { serviceActivityId } }) => {
  await vm.$confirm('是否确认提交', '提示', {
    confirmButtonText: '确认',
    cancelButtonText: '取消'
  });
  try {
    const { data } = await activity.submit({
      serviceActivityId,
      secondaryConfirmation: 0
    });
    errTips(vm, data.data);
    if (+data.code === 2) {
      await vm.$confirm(data.message, '提示', {
        confirmButtonText: '提交',
        cancelButtonText: '取消',
        type: 'warning'
      });
      const res = await activity.submit({
        serviceActivityId,
        secondaryConfirmation: 1
      });
      errTips(vm, res.data.data);
    }
    vm.saveSuccess();
  } catch (e) {
    console.error(
      'error: src/pageproject-record/viewsactive-listconfig/fields.js -- submit',
      e
    );
  }
};

const createActivity = ({ vm, row }) => {
  const creator = createExtend(activeUpdate, {
    activityName: row.activityName,
    serviceActivityId: row.serviceActivityId
  });

  creator['$on']('confirm', () => {
    vm.saveSuccess();
  });
};
const detail = ({ row }) => {
  createExtend(activeDetail, {
    sersviceActivityId: row.serviceActivityId,
    isUnqualified: false
  });
};

export default {
  index: {
    width: '80px',
    label: '序号',
    type: 'index'
  },
  activityName: {
    label: '活动名称',
    prop: 'activityName',
    width: '240px',
    showToolTip: false,
    render(h, ctx, row) {
      const vm = ctx.parent;
      return (
        <div style="display:flex; align-items:center;justify-content:space-between">
          <el-tooltip effect="dark" placement="top" content={row.activityName}>
            <span style="width:240px;text-align:left" class="ellipsis">
              {row.activityName}
            </span>
          </el-tooltip>
          <el-button
            type="text"
            disabled={!!row.submitStatus}
            onClick={createActivity.bind(null, { vm, row })}
          >
            修改
          </el-button>
        </div>
      );
    }
  },
  activityPeopleSum: {
    label: '活动参与人',
    prop: 'activityPeopleSum',
    render(h, ctx, row) {
      return h(baseRowlink, {
        props: {
          text: row.activityPeopleSum + '人'
        },
        on: {
          click: function() {
            const f = createExtend(activePersonList, {
              serviceActivityId: row.serviceActivityId
            });
            f['$on']('remove', () => {
              ctx.parent.saveSuccess();
            });
          }
        }
      });
    }
  },
  submitDt: {
    label: '提交时间',
    prop: 'submitDt'
  },
  submitStatus: {
    label: '服务商状态',
    prop: 'submitStatus',
    formatter(a, b, c) {
      return ['未提交', '已提交'][c];
    }
  },
  auditOssStatus: {
    label: '平台状态',
    prop: 'auditOssStatus',
    formatter(a, b, c) {
      return ['未提交审核', '审核中', '审核通过', '审核未通过'][c];
    }
  },
  handler: {
    width: '240px',
    label: '操作',
    prop: 'handler',
    render(h, ctx, row) {
      const vm = ctx.parent;
      const { submitStatus, activityPeopleSum, isThereAnyAttachment } = row;

      const disabled = submitStatus === 1;
      //被停用，无人数，无附件，已提交
      const sumbitDisabled =
        disabled || !activityPeopleSum || !isThereAnyAttachment;
      return (
        <div>
          <el-button type="text" onClick={detail.bind(null, { row })}>
            查看
          </el-button>
          <el-button
            type="text"
            onClick={personsAdd.bind(null, { h, vm, row })}
            disabled={disabled}
          >
            添加人员
          </el-button>
          <el-button
            type="text"
            onClick={upload.bind(null, { h, vm, row })}
            disabled={disabled}
          >
            上传附件
          </el-button>
          <el-button
            type="text"
            onClick={submit.bind(null, { vm, row })}
            disabled={sumbitDisabled}
          >
            提交
          </el-button>
        </div>
      );
    }
  }
};
